export enum PageName {
  registration = 'registration',
  verification = 'verification',
  verificationV2 = 'verification-v2',
  alreadyHasAccount = 'already-has-account',
  alreadyPaid = 'already-paid',

  emailCollection = 'email-collection',

  selectPlan = 'select-plan',
  paymentScreen = 'payment-screen',
  paymentSuccess = 'payment-success',
  paymentFailed = 'payment-failed',

  // lifetime purchases
  selectLTP = 'select-ltp',
  preLtp = 'pre-ltp',
  ltpPaymentScreen = 'ltp-payment-screen',
  ltpPaymentFailed = 'ltp-payment-failed',

  //OrganicFit
  mainGoal = 'main-goal',
  lifestyle = 'lifestyle',
  libidoBlockers = 'libido-blockers',
  partnersAmount = 'partners-amount',
  diet = 'diet',
  age = 'age',
  age2 = 'age-2',
  choice = 'choice',
  feelSexy = 'feel-sexy',
  timeToTurn = 'time-to-turn',
  orgasmFrequency = 'orgasm-frequency',
  confidence = 'confidence',
  transformSexLife = 'transform-sex-life',
  bodyAndGoals = 'body-and-goals',
  bodyType = 'body-type',
  targetZones = 'target-zones',
  bodyInsecurity = 'body-insecurity',
  height = 'height',
  positions = 'positions',
  reduceCellulite = 'reduce-cellulite',
  fitnessLevel = 'fitness-level',
  breathOut = 'breath-out',
  currentFitness = 'current-fitness',
  feelSexier = 'feel-sexier',

  weight = 'weight',
  weightGoal = 'weight-goal',
  focus = 'focus',
  event = 'event',
  eventDate = 'event-date',
  breakfast = 'breakfast',
  wellbeingImprovement = 'wellbeing-improvement',
  lunch = 'lunch',
  dinner = 'dinner',
  workout = 'workout',
  workSchedule = 'work-schedule',
  describeYourDay = 'describe-your-day',
  water = 'water',
  eatingHabits = 'eating-habits',
  waterIntake = 'water-intake',
  lastIdealWeigh = 'last-ideal-weight',
  audience = 'audience',
  areasToFocus = 'areas-to-focus',
  physicalBuild = 'physical-build',
  dreamBody = 'dream-body',
  weightOnEvents = 'weight-on-events',
  trainingExperience = 'training-experience',
  pilatesExperience = 'pilates-experience',
  flexibility = 'flexibility',
  shortnessOfBreath = 'shortness-of-breath',
  walkingFrequency = 'walking-frequency',
  struggle = 'struggle',
  energyLevels = 'energy-levels',
  sleepRoutine = 'sleep-routine',
  bedroomStamina = 'bedroom-stamina',
  areasToStrength = 'areas-to-strength',
  improveSleep = 'improve-sleep',
  sleep = 'sleep',
  badHabits = 'bad-habits',
  healthierHabits = 'healthier-habits',
  profile = 'profile',
  warmUpScreen = 'warmup-screen',
  preparingPlan = 'preparing-plan',
  weightLossProgram = 'weight-loss-program',
  goals = 'goals',
  meals = 'meals',
  foods = 'foods',
  emptyer = 'emptyer',
  children = 'children',
  feedback = 'feedback',
  predict = 'predict',
  health = 'health',
  fruits = 'fruits',
  plantFoods = 'plant-foods',
  hunger = 'hunger',
  hungry = 'hungry',
  energy = 'energy',
  energyGraph = 'energy-graph',
  oldRoutine = 'old-routine',
  multitasking = 'multitasking',
  clining = 'clining',
  unhealthy = 'unhealthy',
  hitYourGoal = 'hit-your-goal',
  perfectBody = 'perfect-body',
  drive = 'drive',
  priorities = 'priorities',
  aging = 'aging',
  methods = 'methods',
  doctor = 'doctor',
  medications = 'medications',
  menopause = 'menopause',
  vitality = 'vitality',
  motivation = 'motivation',
  mindset = 'mindset',
  uncertain = 'uncertain',
  hitting = 'hitting',
  cravings = 'cravings',
  triggers = 'triggers',
  cook = 'cook',
  break = 'break',
  speed = 'speed',
  name = 'name',
  gender = 'gender',
  build = 'build',
  available = 'available',
  content = 'content',
  help = 'help',
  welcomeScreen = 'welcome-screen',
  warmUpScreen2 = 'warmup-screen-2',
  warmUpScreen3 = 'warmup-screen-3',
  warmUpScreen4 = 'warmup-screen-4',
  warmUpScreen5 = 'warmup-screen-5',
  warmUpScreen6 = 'warmup-screen-6',

  // Senses
  menWorldwide = 'men-worldwide',
  pelvicFloorMuscles = 'pelvic-floor-muscles',
  orgasmAbility = 'orgasm-ability',
  strengtheningPelvicFloor = 'strengthening-pelvic-floor',
  strongPelvicFloor = 'strong-pelvic-floor',
  doInTheBedroom = 'do-in-the-bedroom',
  boostYourPF = 'boost-your-pf',
  typicalDuration = 'typical-duration',
  finishSooner = 'finish-sooner',
  ejaculationControl = 'ejaculation-control',
  keepAnErection = 'keep-an-erection',
  menImprovementsKegel = 'men-improvements-kegel',
  sexualPartner = 'sexual-partner',
  regularityOfSex = 'regularity-of-sex',
  sexDropped = 'sex-dropped',
  drugsToBoost = 'drugs-to-boost',
  outperformMedications = 'outperform-medications',
  drinking = 'drinking',
  smoking = 'smoking',
  eatingRoutine = 'eating-routine',
  physicalActivity = 'physical-activity',
  howOften = 'how-often',
  stressLevel = 'stress-level',
  goodHands = 'good-hands',
  programApart = 'program-apart',
  //woman version
  vulvaOrPenis = 'vulva-or-penis',
  whatDoYouWant = 'what-do-you',
  sensualityDaily = 'sensuality-daily',
  physicalConfident = 'physical-confident',
  kegelExercises = 'kegel-exercises',
  pelvicFeels = 'pelvic-feels',
  pelvicArea = 'pelvic-area',
  givenBirth = 'given-birth',
  sexLife = 'sex-life',
  sexFrequency = 'sex-frequency',
  bedroomExperience = 'bedroom-experience',
  happySexLife = 'happy-sex-life',
  feelingThisPastMonth = 'feeling-this-past-month',
  physicalPractices = 'physical-practices',
  takeCare = 'take-care',
  personalExperience = 'personal-experience',
  mindfulnessTechniques = 'mindfulness-techniques',
  intimateWellbeing = 'intimate-wellbeing',
  chronicMedicalConditions = 'chronic-medical-conditions',
  experiment = 'experiment',
  //Neatsy
  slouching = 'slouching',
  neckHump = 'neck-hump',
  posture = 'posture',
  progress = 'progress',
  sitting = 'sitting',
  stiffness = 'stiffness',
  headache = 'headache',
  fixPosture = 'fix-posture',
  exercise = 'exercise',
  fitnessExperience = 'fitness-experience',
  improvement = 'improvement',
  flexible = 'flexible',
  typicalDay = 'typical-day',
  sittingTime = 'sitting-time',
  legsCross = 'legs-cross',
  heels = 'heels',
  shoulder = 'shoulder',
  sleepPosition = 'sleep-position',
  sleepHours = 'sleep-hours',
}
